export const getServiceCenterAccess = store => {
  return (
    store.underwritingProducerEmailList.serviceCenterAccess &&
    !!store.underwritingProducerEmailList.serviceCenterAccess.is_service_center
  );
};
